import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { UserState } from '../platform-web3/user.state';
import { AdminRecord, GuestRecord, ParentChildRecord, StudentRecord, TeacherRecord } from '../data';

type RoleCombine = TeacherRecord & ParentChildRecord & StudentRecord & AdminRecord & GuestRecord;

/** 學校核心資料 */
@Injectable({
  providedIn: 'root'
})
export class SchoolCoreService {
  private schoolInfoCache = new Map<string, any>();

  constructor(
    private http: HttpClient,
    private store: Store,
  ) { }

  public async getSchoolName(dsns: string): Promise<SchoolName> {
    // 检查缓存中是否已有该 dsns 的数据
    if (this.schoolInfoCache.has(dsns)) {
      return this.schoolInfoCache.get(dsns);
    }

    // 如果缓存中没有，则发送 HTTP 请求
    const url = `/service/school/school_name?dsns=${dsns}`;
    const result = await this.http.get<any>(url).toPromise();

    // 将结果存入缓存
    this.schoolInfoCache.set(dsns, result);

    return result;
  }

}

export interface SchoolName {
  chineseName: string;
  englishName: string;
}
